import { render } from "./userbyid.vue?vue&type=template&id=31c1f15c&scoped=true"
import script from "./userbyid.vue?vue&type=script&lang=js"
export * from "./userbyid.vue?vue&type=script&lang=js"

import "./userbyid.vue?vue&type=style&index=0&id=31c1f15c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tap-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c1f15c"]])

export default __exports__